import { FE_ROLES, ROLES, SITE_ROLES_MAP } from '../config/consts';
import { FERoles } from '../modules/commonTypes';
import { CONTEXT } from '../modules/user';
import { isUserReadOnly } from '../modules/user/utils';

export const isApartmentAdmin = (companies) =>
  !!companies?.find((company) =>
    company?.sites?.find((site) =>
      site?.apartments?.find((apartment) => apartment?.roles?.includes(ROLES.APARTMENT_ADMIN))
    )
  );

export const canUserDelete = (toDeleteUser, currentUser, context, siteIdsInfo = undefined) => {
  const currentUserRole = currentUser && siteIdsInfo && getCurrentRole(currentUser, siteIdsInfo, context);
  const toDeleteUserRole = toDeleteUser?.role;

  return (
    isDifferentUser(currentUser, toDeleteUser) &&
    contextAllowsDeletionOfRole(toDeleteUserRole, context) &&
    roleCanBeDeletedByUserRole(currentUserRole, toDeleteUserRole)
  );
};

function isDifferentUser(currentUser, toDeleteUser) {
  return toDeleteUser?.id !== currentUser?.id;
}

function contextAllowsDeletionOfRole(toDeleteUserRole, context) {
  if (context === CONTEXT.COMPANY_ADMINS) {
    return true;
  }
  return toDeleteUserRole !== FERoles.COMPANY_ADMIN;
}

function roleCanBeDeletedByUserRole(currentUserRole, toDeleteUserRole) {
  if (isUserReadOnly(toDeleteUserRole)) {
    return false;
  }
  if (currentUserRole === FERoles.COMPANY_ADMIN) {
    return true;
  }
  if ([FERoles.SITE_ADMIN_PAYMENT, FERoles.SITE_ADMIN].includes(currentUserRole)) {
    return ![FERoles.COMPANY_ADMIN, FERoles.SITE_ADMIN_PAYMENT].includes(toDeleteUserRole);
  }
  return true;
}

export const getCurrentRole = (data, validation, context) => {
  const company = data?.companies?.find((item) => item.id === validation.companyId);
  const siteRoles = company?.sites?.find((item) => item.id === validation.siteId)?.roles;
  const companyRoles = company?.roles;

  if (context === CONTEXT.COMPANY_ADMINS || companyRoles?.includes(ROLES.COMPANY_ADMIN)) {
    return FE_ROLES.COMPANY_ADMIN;
  }

  if (siteRoles?.includes(ROLES.ADMIN) && companyRoles?.includes(ROLES.MOBILE_VIDEO_BUYER)) {
    return FE_ROLES.SITE_ADMIN_PAYMENT;
  }

  if (siteRoles?.includes(ROLES.ADMIN)) {
    return FE_ROLES.SITE_ADMIN;
  }

  return FE_ROLES.SITE_USER;
};

export const onSetRole = (setRole, userRole, data, validation, context) => {
  const role = getCurrentRole(data, validation, context);
  if (role && userRole && role !== userRole) {
    setRole(data.id, {
      grantedRoles: {
        companyRoles: SITE_ROLES_MAP?.[role]?.[userRole].grantedRoles.companyRoles.length
          ? [
              {
                companyId: validation.companyId,
                types: SITE_ROLES_MAP?.[role]?.[userRole].grantedRoles.companyRoles,
              },
            ]
          : [],
        siteRoles: SITE_ROLES_MAP?.[role]?.[userRole].grantedRoles.siteRoles.length
          ? [
              {
                siteId: validation.siteId,
                types: SITE_ROLES_MAP?.[role]?.[userRole].grantedRoles.siteRoles,
              },
            ]
          : [],
      },
      revokedRoles: {
        companyRoles: SITE_ROLES_MAP?.[role]?.[userRole].revokedRoles.companyRoles.length
          ? [
              {
                companyId: validation.companyId,
                types: SITE_ROLES_MAP?.[role]?.[userRole].revokedRoles.companyRoles,
              },
            ]
          : [],
        siteRoles: SITE_ROLES_MAP?.[role]?.[userRole].revokedRoles.siteRoles.length
          ? [
              {
                siteId: validation.siteId,
                types: SITE_ROLES_MAP?.[role]?.[userRole].revokedRoles.siteRoles,
              },
            ]
          : [],
      },
    });
  }
};
